import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './index.scss';
import '../../../../../../assets/images-svg-sprite/crtf_ic.svg';

const LinkDownload = props => {
    const [
        { fileName, linkDisplayName, fileType, filesize, updatedOn, link },
        translations,
    ] = props.data;
    const linkFileName = fileName || '';
    return (
        <div className={styles.popupTableRow}>
            <div
                className={classNames({
                    [styles.popupTableColumn]: true,
                    [styles.withOutSize]: !props.showSize,
                })}
            >
                <div className={styles.wrapperFileIcon}>
                    <svg className={styles.icon}>
                        <use xlinkHref="#crtf_ic" />
                    </svg>
                </div>
                <div>{linkDisplayName !== null ? linkDisplayName : linkFileName}</div>
            </div>
            <span className={styles.popupTableColumn}>{fileType || ''}</span>
            {props.showSize ? (
                <span className={styles.popupTableColumn}>{filesize > 0 ? filesize : ''}</span>
            ) : null}

            <span className={styles.popupTableColumn}>{updatedOn}</span>
            <span className={styles.popupTableColumn}>
                <div className={styles.downloadBtnWrapper}>
                    <a
                        className={classNames({
                            [styles.downloadLink]: true,
                            'btn-se btn-se_color_blue': true,
                        })}
                        href={`${link}${linkFileName}`}
                        download
                    >
                        {translations['pdp.label.download']}
                    </a>
                </div>
            </span>
        </div>
    );
};

const ContentDownload = props => {
    const { pic, partnumber, name, translations, downloadLinks } = props.data;
    return (
        <React.Fragment>
            <div className={styles.popupHeader}>
                <div className={styles.popupHeaderImgWrapper}>
                    <img className={styles.popupHeaderImg} src={pic} />
                </div>
                <div className={styles.popupHeaderContent}>
                    <div className={styles.popupProductName}>{name}</div>
                    <span className={styles.popupSku}>{partnumber}</span>
                </div>
            </div>
            <div className={styles.popupContentFilesContent}>
                <div className={styles.contentHeader}>
                    {translations['finder.software.availableVersions']}
                </div>
                <div className={styles.popupTable}>
                    <div
                        className={classNames({
                            [styles.popupTableRow]: true,
                            [styles.popupTableRowHeadRow]: true,
                        })}
                    >
                        <div
                            className={classNames({
                                [styles.popupTableColumn]: true,
                                [styles.withOutSize]: !props.showSize,
                            })}
                        >
                            {translations['software.download.fileTitle']}
                        </div>
                        <div className={styles.popupTableColumn}>
                            {translations['software.download.fileType']}
                        </div>
                        {props.showSize ? (
                            <div className={styles.popupTableColumn}>
                                {translations['software.download.fileSize']}
                            </div>
                        ) : null}

                        <div className={styles.popupTableColumn}>
                            {translations['software.updatedOn']}
                        </div>
                        <div className={styles.popupTableColumn} />
                    </div>
                    {downloadLinks.map((item, index) => (
                        <LinkDownload
                            showSize={props.showSize}
                            key={`download-link-${index}`}
                            data={[item, translations]}
                        />
                    ))}
                </div>
            </div>
        </React.Fragment>
    );
};

let wasClickIn = false;
class DownloadPopup extends Component {
    constructor(props) {
        super(props);
        window.addEventListener('keydown', e => {
            if (e.keyCode === 27 && document.body.classList.contains('modal-open')) {
                props.closePopup();
            }
        });
    }
    render() {
        return (
            <div
                className={styles.popupWrapper}
                onClick={() => {
                    if (!wasClickIn) {
                        this.props.closePopup();
                    }
                    wasClickIn = false;
                }}
            >
                <div className={styles.popup}>
                    <div onClick={() => this.props.closePopup()} className={styles.popupClose} />
                    <div
                        onClick={() => {
                            wasClickIn = true;
                        }}
                        className={styles.popupContent}
                    >
                        {this.props.data ? (
                            <ContentDownload
                                showSize={this.props.data.downloadLinks.some(
                                    item => item.filesize !== '0',
                                )}
                                data={this.props.data}
                            />
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}

DownloadPopup.propTypes = {
    closePopup: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
};
ContentDownload.propTypes = {
    showSize: PropTypes.bool.isRequired,
    data: PropTypes.object.isRequired,
};
LinkDownload.propTypes = {
    showSize: PropTypes.bool.isRequired,
    data: PropTypes.array.isRequired,
};

export default DownloadPopup;
